import React, { Fragment } from 'react'
import Navbarmenu from '../Header/ Navbarmenu'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Routers from '../../routers/Routers'
import NewHeader from '../Header/NewHeader'

const Layout = () => {
  return <Fragment>
    {/* <Navbarmenu /> */}
      <NewHeader />
      <div>
          <Routers />
      </div>
      <Footer />
  </Fragment>
}

export default Layout
